import { combineReducers } from "redux";

import requestSlice from "./requestSlice.ts";

const administrationReducer = combineReducers({
  requests: requestSlice,
});

export default administrationReducer;
